import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const addTrackedBrands = async (pageIds = []) => {
  const token = await firebase.auth().currentUser?.getIdToken()

  const { data } = await AxiosConfig.post(
    '/spyder/track',
    { pageIds },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const getTrackedBrands = async () => {
  const token = await firebase.auth().currentUser?.getIdToken()
  const { data } = await AxiosConfig.get(
    '/spyder/tracked-brands',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const checkSpyderOverage = async () => {
  const token = await firebase.auth().currentUser?.getIdToken()
  const { data } = await AxiosConfig.get(
    '/spyder/overage',
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return data
}

// pageRemovals [] { pageId: string, folderId: string | null}
const removeTrackedBrands = async (pageRemovals = []) => {
  const token = await firebase.auth().currentUser?.getIdToken()
  const { data } = await AxiosConfig.delete(
    '/spyder/track',
    {
      data: { pageRemovals },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

const getBrandPreview = async (pageId) => {
  const user = await firebase.auth().currentUser
  const authToken = await user.getIdToken()

  const { data } = await AxiosConfig.get(
    `/spyder/preview/${pageId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`
      }
    }
  )
  return data
}

// Is the current user/team tracking this brand
const getTrackingStatus = async (brandId) => {
  const token = await firebase.auth().currentUser?.getIdToken()

  const { data } = await AxiosConfig.get(
    `/spyder/tracking-status/${brandId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return data?.data ?? { isTracking: false }
}

const getSubscription = async ({ brandId, pageId } = {}) => {
  const token = await firebase.auth().currentUser?.getIdToken()

  const { data } = await AxiosConfig.get(
    '/spyder/subscription',
    {
      params: brandId ? { brandId } : { pageId },
      headers: { Authorization: `Bearer ${token}` }
    }
  )
  return data?.data ?? null
}

const getTrackedStatus = async (adLibraryIds = []) => {
  if (!adLibraryIds.length) return {}
  const token = await firebase.auth().currentUser?.getIdToken()

  const uniqueIds = [...new Set(adLibraryIds.map(String))]
  const chunks = []
  for (let i = 0; i < uniqueIds.length; i += 100) {
    chunks.push(uniqueIds.slice(i, i + 100))
  }

  const responses = await Promise.all(chunks.map(chunk =>
    AxiosConfig.get(
      '/spyder/tracked-status',
      {
        params: { adLibraryIds: chunk.join(',') },
        headers: { Authorization: `Bearer ${token}` }
      }
    )
  ))

  return responses.reduce((acc, { data }) => ({ ...acc, ...(data?.data ?? {}) }), {})
}

export default {
  addTrackedBrands,
  getTrackedBrands,
  removeTrackedBrands,
  checkSpyderOverage,
  getBrandPreview,
  getTrackingStatus,
  getSubscription,
  getTrackedStatus
}
